import Vue from 'vue'
import store from './store'
import App from './App.vue'
import router from '@/router/index'
import { applyRouteSeo } from "./utils/seo";
import '@/assets/styles/index.scss'
import './plugins/element.js'
import Element from 'element-ui'
import './assets/icons' // icon
import 'element-ui/lib/theme-chalk/index.css'
import { beforeUpload } from "@/plugins/index";
Vue.prototype.beforeUpload = beforeUpload
Vue.use(Element)
import timeDivSelect from 'timedivselect'
Vue.use(timeDivSelect)
Vue.config.productionTip = false
import VueScrollReveal from 'vue-scroll-reveal';
import "animate.css"
import "wowjs/css/libs/animate.css"
import { selectDictLabel, selectDictLabels,getDateDiff,getTotalMoney,handleTree,datePropRange,clearDuplicate } from "@/utils/index";
import { getDicts } from "@/api/request";
// 字典数据组件
import DictData from '@/components/DictData'
Vue.prototype.getDicts = getDicts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
import wow from 'wowjs'
import VueLazyLoad from 'vue-lazyload'
import dictMixins from './mixins/dict'
Vue.mixin(dictMixins)
import download from '@/plugins/download.js'
Vue.prototype.$download = download
import controlClickState from '@/plugins/controlClickState'
Vue.use(controlClickState)
import moment from "moment"
Vue.prototype.$moment = moment;
//订单相关工具
import orderUtils from "../src/pages/common/orderUtils.js"
//加密方法
import { encryptionPhoneNumber , encryptionEmail } from './utils/encryption.js'
Vue.use(VueLazyLoad,{
    error:'./assets/default.png',
    loading:'./assets/default.png'
})
import loadmore from '@/plugins/tableLoadmore' // 表格滚动加载
loadmore.install(Vue)
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.getDateDiff = getDateDiff
Vue.prototype.getTotalMoney = getTotalMoney
Vue.prototype.handleTree = handleTree
Vue.prototype.$orderUtils = orderUtils
Vue.prototype.datePropRange = datePropRange
Vue.prototype.clearDuplicate= clearDuplicate
Vue.prototype.encryptionPhoneNumber = encryptionPhoneNumber
Vue.prototype.encryptionEmail = encryptionEmail
DictData.install()
Vue.prototype.$wow = wow
Vue.use(VueScrollReveal,{
  class: 'v-scroll-reveal',  
  // 动画的时长
  duration: 600,
  // 延迟时间
  delay: 200,
  // 动画开始的位置，'bottom', 'left', 'top', 'right'
  origin: 'bottom',
  // 回滚的时候是否再次触发动画
  reset: false,
  // 在移动端是否使用动画
  mobile: false,
  // 滚动的距离，单位可以用%，rem等
  distance: '30px',
  // 其他可用的动画效果
  opacity: 0.001,
  easing: 'linear',
  // scale: 0.9,
  });
router.afterEach((to) => {
  applyRouteSeo(to);
});
applyRouteSeo(router.currentRoute);
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
